import { Box, Button, useTheme } from '@mui/material';
import { FC } from 'react';

interface Props {
  icon: React.FC;
  isActive?: boolean;
  onClick?: () => void;
}

const RateButton: FC<Props> = ({
  children,
  onClick,
  icon: Icon,
  isActive = false,
}) => {
  const theme = useTheme();
  return (
    <Button
      onClick={onClick}
      variant={isActive ? 'rounded' : 'outlined'}
      sx={{
        color: isActive ? theme.palette.grey[900] : theme.palette.grey[400],
        borderColor: theme.palette.grey[400],
        borderRadius: 3,
        fontWeight: 500,
        fontSize: 12,
        lineHeight: '24px',
        letterSpacing: 1,
      }}
    >
      {children}
      <Box
        sx={{
          marginLeft: 2,
          display: 'flex',
        }}
      >
        <Icon />
      </Box>
    </Button>
  );
};

export default RateButton;
